"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
var _Layout = _interopRequireDefault(require("../Layout"));
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CompleteBackground = function CompleteBackground(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styles.Background, rest, /*#__PURE__*/_react["default"].createElement(_Layout["default"].ContentWrapper, {
    justifyContent: "center",
    flex: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_styles.CenterWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.Assistant, {
    width: 45,
    height: 45
  }), children)));
};
CompleteBackground.propTypes = {
  children: _propTypes["default"].node
};
var _default = exports["default"] = CompleteBackground;